

































import { Component, Prop, Watch, Vue, Mixins, Ref } from "vue-property-decorator";
import { VIEWPOINT_API } from "@/api/ViewpointApi";
import { Logger } from 'aws-amplify';
import { Bar } from "vue-chartjs";
import BarChart from "./BarChart.vue";
import ApexBarChart from "./ApexBarChart.vue";
import HistogramSlider from "./HistogramSlider.vue";


// Logger.LOG_LEVEL = "DEBUG";
const logger = new Logger("Histogram.vue");

@Component({
    components: { BarChart, ApexBarChart, HistogramSlider }
})
export default class Histogram extends Vue {

    @Prop({type: String, default: ''})
    decisionId!: string;

    @Prop({type: String, default: ''})
    factorId!: string;  

    @Prop({type: String, default: 'Factor'})
    factorName!: string;  
    
    private histogramData: any = {};
    private chartData: any = {};
    private labels: any[] = [];
    private options: any = {
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true
                },
                gridLines: {
                    display: true
                }
            }],
            xAxes: [{
                ticks: {
                    beginAtZero: false
                },
                gridLines: {
                    display: true,
                    offsetGridLines: false,
                }
            }]
        },
        maintainAspectRatio: false,
        responsive: true,
    };

    mounted () {
        /*
        *  Calling this.init() because mounted() CANNOT be async and
        *  we need to use asynchromous functions when requesting data
        *  via an API so we don't stop the application
        */ 

        this.init(); 
    }

    public async init() {
        let res: any = await VIEWPOINT_API.getHistogram(this.decisionId, this.factorId);
        this.labels = this.cleanWidths(res.binWidths);
        this.histogramData = res;
        this.fillData();
    }
    
    private fillData() {
        this.chartData =  {
            labels: this.cleanWidths(this.histogramData.binWidths),
            datasets: [
                {
                    label: this.factorName,
                    backgroundColor: '#004466',
                    pointBackgroundColor: 'white',
                    pointBorderColor: '#666',
                    categoryPercentage: 1,
                    barPercentage: 1,
                    data: this.histogramData.binCounts
                }
            ]
        };

    }

    private cleanWidths(binWidths: any[]): any[] {
        let cleanWidths: any[] = binWidths.map( (width: number) => String(width.toFixed(1)) );
        let newWidths: any[] = [];
        if (cleanWidths.length > 1) {
            cleanWidths.forEach( (width: number, index: number) => {
                if ( index < (cleanWidths.length - 1) ) {
                    newWidths.push('[' + cleanWidths[index] + '-' + cleanWidths[index + 1] + ']');
                }
            });
        }
        return newWidths;
    }

}


